import { RequestActionDefinition } from './RequestActionDefinition.js';
import { extendJSONSchema } from '../utils/extendJSONSchema.js';

export const ResourceCountActionDefinition = extendJSONSchema(
  RequestActionDefinition,
  {
    type: 'object',
    additionalProperties: false,
    required: ['type', 'resource'],
    properties: {
      type: {
        enum: ['resource.count'],
        description:
          'Count the number of resources a similar `resource.query` action would return.',
      },
      resource: {
        type: 'string',
        description: 'The type of the resource to count.',
      },
      selectedGroupId: {
        $ref: '#/components/schemas/RemapperDefinition',
        description:
          'The ID of the group to scope the request to. Defaults to the currently selected group.',
      },
      own: {
        type: 'boolean',
        description:
          'If only the resources created by the authenticated app member should be included',
      },
    },
  },
  ['url', 'method'],
);
